import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Store } from '@ngrx/store';
import { SpecificationFormState } from '@ordersnproducts/modules/order-builder/modules/specification/reducers/specification/specification.reducer';
import { AbstractCatalogOptionLoader } from '@ordersnproducts/modules/order-builder/modules/specification/services/loaders/catalog-option-loader.service';
import { getFirstCalendar, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { CatalogCodeType, CATALOG_CODE } from '@ordersnproducts/modules/shared/constants/catalog-codes';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-i';
import { Features } from '@ordersnproducts/features';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { BOOM_PUMP, PUMP, STATIONARY_PUMP } from '../../../constants/pumps';
import { hasPumpAndHasDifferentToPump } from '../../../helpers/should-hide-pump';

export const PumpTypes = [{ id: 'PUMP' }, { id: 'OWN_PUMP' }, { id: BOOM_PUMP }, { id: STATIONARY_PUMP }];
@Injectable()
export class PumpableUnloadTypeOptionLoader extends AbstractCatalogOptionLoader {
  private rmsStore: Store<OrderBuilderState>;

  constructor(
    featureToggleService: FeatureToggleService,
    store: Store<SpecificationFormState>,
    rmsStore: Store<OrderBuilderState>,
  ) {
    super(store, featureToggleService);
    this.rmsStore = rmsStore;
  }

  getCatalogType(): CatalogCodeType {
    return CATALOG_CODE.UNLOAD_TYPE;
  }

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return combineLatest([super.loadOptions(formGroup), this.hasPumpAndHasDifferentToPump(formGroup)]).pipe(
      map(([options, result]) => {
        if (!result.isPumpable) {
          const filtered = options.filter((option) => {
            return !PumpTypes.some((pumpType) => pumpType.id === option.id);
          });
          return { options: filtered, pumpable: result.isPumpable };
        } else {
          return { options, pumpable: result.isPumpable };
        }
      }),
      switchMap(({ options, pumpable }) => {
        return this.store.select(getFirstCalendar).pipe(
          filter((calendar) => !!calendar),
          take(1),
          map((calendar) => {
            const isBoomPumpActivated = this.featureToggleService.isFeatureEnabled(Features.BoomPump);
            if (isBoomPumpActivated && pumpable) {
              // Remove normal pump
              options = options.filter((item) => item.id !== PUMP);
            } else {
              options = options.filter((item) => ![BOOM_PUMP, STATIONARY_PUMP].includes(item.id));
            }

            return options;
          }),
        );
      }),
    );
  }

  private hasPumpAndHasDifferentToPump(formGroup: UntypedFormGroup) {
    return hasPumpAndHasDifferentToPump(this.rmsStore, formGroup);
  }
}
